"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _googleMapReact = _interopRequireDefault(require("google-map-react"));

var _reactGeocode = _interopRequireDefault(require("react-geocode"));

var _antd = require("antd");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _icons = require("@ant-design/icons");

var _theme = require("../../theme");

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Marker = function Marker() {
  return /*#__PURE__*/_react.default.createElement(Icon, null, /*#__PURE__*/_react.default.createElement(_icons.EnvironmentTwoTone, null));
};

var Map = function Map(props) {
  var site = props.site,
      value = props.value,
      onChange = props.onChange;
  var defaultValue = value || {
    lat: 59.95,
    lng: 30.33,
    address: ''
  };
  (0, _react.useEffect)(function () {
    (site === null || site === void 0 ? void 0 : site.googleMapsApi) && _reactGeocode.default.setApiKey(site.googleMapsApi);
  }, []);

  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address) {
      var _result$results, result, _ref3, _ref3$geometry$locati, lat, lng, formatted_address;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _reactGeocode.default.fromAddress(address);

            case 3:
              result = _context.sent;
              _ref3 = result === null || result === void 0 ? void 0 : (_result$results = result.results) === null || _result$results === void 0 ? void 0 : _result$results[0], _ref3$geometry$locati = _ref3.geometry.location, lat = _ref3$geometry$locati.lat, lng = _ref3$geometry$locati.lng, formatted_address = _ref3.formatted_address;

              if (lat, lng) {
                onChange({
                  address: formatted_address || '',
                  lat: lat,
                  lng: lng
                });
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function handleSearch(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleGeocode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lat, lng) {
      var _result$results2, result, _ref5, formatted_address;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _reactGeocode.default.fromLatLng(lat, lng);

            case 2:
              result = _context2.sent;
              _ref5 = result === null || result === void 0 ? void 0 : (_result$results2 = result.results) === null || _result$results2 === void 0 ? void 0 : _result$results2[0], formatted_address = _ref5.formatted_address;

              if (formatted_address) {
                onChange({
                  address: formatted_address,
                  lat: lat,
                  lng: lng
                });
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleGeocode(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleChange = function handleChange(e) {
    onChange(_objectSpread(_objectSpread({}, defaultValue), {}, {
      address: e.target.value
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, site !== null && site !== void 0 && site.googleMapsApi ? /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Input.Search, {
    value: defaultValue.address,
    onChange: handleChange,
    onSearch: function onSearch() {
      return handleSearch(defaultValue.address);
    },
    placeholder: (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.address) || 'Enter an address'
  }), /*#__PURE__*/_react.default.createElement(MapContainer, null, /*#__PURE__*/_react.default.createElement(_googleMapReact.default, {
    height: true,
    bootstrapURLKeys: {
      key: site.googleMapsApi
    },
    defaultCenter: {
      lat: 59.95,
      ln: 30.33
    },
    defaultZoom: 11,
    center: [defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.lat, defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.lng],
    onClick: function onClick(_ref) {
      var lat = _ref.lat,
          lng = _ref.lng;
      return handleGeocode(lat, lng);
    }
  }, (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.lat) && (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.lng) && /*#__PURE__*/_react.default.createElement(Marker, {
    lat: defaultValue.lat,
    lng: defaultValue.lng
  })))) : /*#__PURE__*/_react.default.createElement(_antd.Typography, null, "Please add GoogleMaps API key in settings."));
};

var MapContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 220px;\n  width: 100%;\n  background: ", ";\n"])), _theme.colors.tertiary);

var Icon = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  svg {\n    height: 26px;\n    width: 20px;\n  }\n"])));

var _default = Map;
exports.default = _default;